// extracted by mini-css-extract-plugin
module.exports = {"field":"CheckBox_field__MHZ9K","checkBoxBase":"CheckBox_checkBoxBase__ALQoR","checkBoxSlider":"CheckBox_checkBoxSlider__77ucv"};